import emailjs from "emailjs-com";

interface EmailParams {
  from_name: string;
  to_name?: string;
  full_name: string;
  email: string;
  phone_number: string;
  job_title: string;
  company: string;
  interested_in: string;
}

const sendEmail = async (params: EmailParams) => {
  const templateParams = {
    from_name: params.from_name,
    to_name: params.to_name || "Alexandre Lorega",
    full_name: params.full_name || "Not provided",
    email: params.email || "Not provided",
    phone_number: params.phone_number || "Not provided",
    job_title: params.job_title || "Not provided",
    company: params.company || "Not provided",
    interested_in: params.interested_in || "Not specified",
  };

  try {
    const response = await emailjs.send(
      "service_en42wpe",
      "lorega_template",
      templateParams,
      "4xvcwRX1Wbkbw-Zi-",
    );
    return response;
  } catch (error) {
    console.error("Failed to send email:", error);
    throw error;
  }
};

export default sendEmail;
